// services/categoryGroups.js — групите на категориите на разходите (ПРОМТ-46).
//
// Макс (02.11.2026): при избора на категория да се вижда към коя група е —
// 601 са материали, 602 услуги, 609 другите. Групата НЕ се пише в конфига, а
// се вади от сметката: иначе би имало две истини („Наем" в група „Материали"
// със сметка 602). Ползва се и от сървъра (проверката на конфига), и от екрана
// (заглавията в търсачката) — затова е без require.
//
// Редът тук е редът на групите при равен брой съвпадения. 62x (лихви, банкови
// такси) е при „Други": Макс ги премести от 609 на 621/629 на 29.10.2026, но за
// човека, който избира, те са „други разходи", не отделна група.

const GROUPS = [
  { key: 'materials', label: 'Материали', re: /^601/ },
  { key: 'services', label: 'Услуги', re: /^602/ },
  { key: 'other', label: 'Други', re: /^(60[03-9]|62)/ },
  // само във фирма със склад (своя категория по 30x); по 20x — ДМА
  { key: 'stock', label: 'Стоки и материали на склад', re: /^30/ },
  { key: 'assets', label: 'Дълготрайни активи', re: /^20/ },
];

// Ключът на групата по сметката; null — сметка извън разходите (такава
// категория не се допуска).
function groupOf(account) {
  const a = String(account == null ? '' : account).trim();
  const g = GROUPS.find((x) => x.re.test(a));
  return g ? g.key : null;
}

// Заглавието: „Услуги (602)", „Други (609, 621, 629)" — сметките са тези на
// показаните категории, за да не обещава заглавието сметка, която я няма.
function groupTitle(key, accounts) {
  const g = GROUPS.find((x) => x.key === key);
  const list = [...new Set((accounts || []).map((a) => String(a || '').trim()).filter(Boolean))].sort();
  return (g ? g.label : 'Други') + (list.length ? ' (' + list.join(', ') + ')' : '');
}

module.exports = { GROUPS, groupOf, groupTitle };
